module.exports = __webpack_public_path__ + "img/banner_1928.63b30ec6.png";